import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04bde2f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "outer-container",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "button-container" }
const _hoisted_3 = ["selected", "disabled"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon fa fa-hand-pointer" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon fa fa-play" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon fa fa-pause" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon fa fa-stop" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolbarItem = _resolveComponent("ToolbarItem")!

  return (_openBlock(), _createBlock(_component_ToolbarItem, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('toolbar.tts')) + ":", 1),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            selected: _ctx.clickToSpeakEnabled == true,
            disabled: _ctx.clickToSpeakEnabled == false && _ctx.isPlaying == true,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleClickToSpeak()))
          }, _hoisted_5, 8, _hoisted_3),
          _createElementVNode("button", {
            disabled: _ctx.isPlaying == true || _ctx.clickToSpeakEnabled == true,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.play()))
          }, _hoisted_8, 8, _hoisted_6),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pause()))
          }, _hoisted_10),
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.stop()))
          }, _hoisted_12)
        ])
      ])
    ]),
    _: 1
  }))
}